import React, { createContext } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

interface ILoggingProviderState {
  appInsights: ApplicationInsights | undefined;
}
const initialState: ILoggingProviderState = {
  appInsights: undefined
};
const loggingContext = createContext(initialState);
const { Provider } = loggingContext;

interface ILoggingProviderProps {
  appInsights: ApplicationInsights;
  children: React.ReactNode;
}

const LoggingProvider = (props: ILoggingProviderProps): JSX.Element => {
  return <Provider value={{ appInsights: props.appInsights }}>{props.children}</Provider>;
};

export { LoggingProvider, loggingContext as LoggingContext };
